import { RouteObject } from "react-router-dom";
import { TemplatePage } from "./ui/TemplatePage";

/**
 * 템플릿 페이지 컴포넌트 라우트
 *
 * 설정 사항:
 * 1. path를 원하는 경로로 변경하세요
 * 2. TemplatePage를 원하는 컴포넌트로 변경하세요
 * 3. export명을 변경하세요 (templateRoute → myPageRoute)
 */
export const templateRoute: RouteObject = {
  path: "/template",
  element: <TemplatePage />,
};
